var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPositionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4286 6V6.5H15.9286H21.4286C21.72 6.5 21.9952 6.61074 22.1945 6.80102L22.5397 6.43934L22.1945 6.80102C22.393 6.99054 22.5 7.24249 22.5 7.5V19.5C22.5 19.7575 22.393 20.0095 22.1945 20.199C21.9952 20.3893 21.72 20.5 21.4286 20.5H2.57143C2.27996 20.5 2.00484 20.3893 1.8055 20.199L1.46154 20.5593L1.8055 20.199C1.60695 20.0095 1.5 19.7575 1.5 19.5V7.5C1.5 7.24249 1.60695 6.99054 1.8055 6.80102C2.00484 6.61074 2.27996 6.5 2.57143 6.5H8.07143H8.57143V6V4.5C8.57143 4.24249 8.67838 3.99054 8.87693 3.80102L8.53646 3.44434L8.87693 3.80102C9.07626 3.61074 9.35139 3.5 9.64286 3.5H14.3571C14.6486 3.5 14.9237 3.61074 15.1231 3.80102C15.3216 3.99054 15.4286 4.24249 15.4286 4.5V6ZM9.64286 4H9.14286V4.5V6V6.5H9.64286H14.3571H14.8571V6V4.5V4H14.3571H9.64286ZM21.9286 7.5V7H21.4286H2.57143H2.07143V7.5V14.25V14.75H2.57143H21.4286H21.9286V14.25V7.5ZM2.07143 19.5V20H2.57143H21.4286H21.9286V19.5V15.75V15.25H21.4286H2.57143H2.07143V15.75V19.5Z",
    fill: "#696F7A",
    stroke: "#696F7A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 13H13C13.2652 13 13.5196 12.8946 13.7071 12.7071C13.8946 12.5196 14 12.2652 14 12C14 11.7348 13.8946 11.4804 13.7071 11.2929C13.5196 11.1054 13.2652 11 13 11H11C10.7348 11 10.4804 11.1054 10.2929 11.2929C10.1054 11.4804 10 11.7348 10 12C10 12.2652 10.1054 12.5196 10.2929 12.7071C10.4804 12.8946 10.7348 13 11 13Z",
    fill: "#696F7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositionIcon);
export default __webpack_public_path__ + "static/media/positionIcon.c3bf3890b930a5caf15c1ac36d2c7be0.svg";
export { ForwardRef as ReactComponent };